module.exports = __webpack_public_path__ + "img/21치즈스틱(행사).4ed7c79b.png";